import { useQuery } from "react-query"

import { useConfig } from "../components/ConfigContext"
import { load, matchesGroup, sortAlphabetical } from "../lib"

const loadGroups = (filters = {}, apiUrl) => {
  const { officeId, type } = filters;
  const request = load(`${apiUrl}/groups`, {
    filter: {
      where: {
        officeId,
        type,
      }
    }
  })
  const result = request
    .then(groups => groups.filter(matchesGroup(filters)))
    .then(sortAlphabetical)

  result.cancel = request.cancel;
  return result;
}

export const useGroups = (filter, options) => {
  const { apiUrl } = useConfig();

  return useQuery(
    ['groups', filter],
    () => loadGroups(filter, apiUrl),
    options
  )
}
